import * as z from "zod";

const webhookStatusSchema = z.enum(["active", "disabled"]);
const webhookTopicSchema = z.enum([
  "return",
  "label",
  "shipment",
  "consolidation_shipment",
  "warehouse_return_processed",
]);
const webhookKindSchema = z.enum(["redo", "loop"]);
const webhookEventStatusSchema = z.enum(["success", "failed", "pending"]);

const lastEventSchema = z.object({
  createdAt: z.date(),
  status: webhookEventStatusSchema,
});

const teamWebhookSchema = z.object({
  _id: z.string(),
  url: z.string(),
  bearerToken: z.string(),
  externalId: z.string().nullable(),
  topic: webhookTopicSchema,
  kind: webhookKindSchema,
  status: webhookStatusSchema.optional(),
  lastEvent: lastEventSchema.nullable().optional(),
});

export type TeamWebhookOutput = z.infer<typeof teamWebhookSchema>;

export const getTeamWebhooks = {
  name: "getTeamWebhooks" as const,
  input: z.object({}),
  output: z.object({ webhooks: z.array(teamWebhookSchema) }),
};
